const PAYMENT_STATUS_LABELS: Record<string, string> = {
  UNPAID: "未支付",
  PAID: "已支付",
  PENDING: "待支付",
  PREORDER: "预下单",
  PAYMENT_FAILED: "支付失败",
  PAYMENT_TIMEOUT: "支付超时",
  CANCELLED: "已取消",
  REFUNDED: "已退款",
};

const NOTIFY_STATUS_LABELS: Record<string, string> = {
  PENDING: "未发货",
  NOTIFIED: "已发货",
  FAILED: "发货失败",
};

export function paymentStatusLabel(status: string): string {
  const key = (status || "").trim().toUpperCase();
  if (!key) return "—";
  return PAYMENT_STATUS_LABELS[key] || status;
}

export function notifyStatusLabel(status: string): string {
  const key = (status || "").trim().toUpperCase();
  if (!key) return "未发货";
  return NOTIFY_STATUS_LABELS[key] || status;
}

export function paymentStatusColor(
  status: string
): "default" | "success" | "processing" | "error" | "warning" {
  switch ((status || "").trim().toUpperCase()) {
    case "PAID":
      return "processing";
    case "UNPAID":
      return "default";
    case "PAYMENT_FAILED":
    case "CANCELLED":
      return "error";
    case "PAYMENT_TIMEOUT":
      return "warning";
    default:
      return "default";
  }
}
